import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { history } from "../../../../store/configure/configureStore";
import {
  FaPlus,
  FaEllipsisVertical,
  FaEye,
  FaPen,
  FaBrush,
  FaArrowLeftLong,
} from "react-icons/fa6";
import { MdDelete, MdSearch } from "react-icons/md";
import { capitalizeWords } from "../../../../utils/common";
import { SEND_NOTIFICATION_TO_USERS } from "../../../../navigation/routes";
import placeholderImageForUpload from "../../../../assets/images/placeholderImageForUpload.png";

import { Header, DataTable } from "../../../common";
import {
  ButtonView,
  CardView,
  Input,
  Select,
  ModalView,
} from "../../../controls";

import "./UpdateNotificationStyles.scss";

const UpdateNotificationView = ({
  //
  id,
  fields,
  initialFields,
  errors,
  //
  handleInputChange,
  handleActionButtonInputChange,
  handleDropdownSelectionForPlatform,
  handleFileChange,
  handleOnClickRemoveImage,
  //
  onClickAddActionButton,
  onClickRemoveActionButton,
  onClickSave,
  //
  platformsDropDownOptions,
  //
  userPermissions,
  //
  hasFieldsChanged,
  //
  onClickCancel,
}) => {
  // console.log("userData", userPermissions);

  var actionButtons = fields?.actionButtons;

  const renderTextInputField = ({
    name,
    label,
    isRequired,
    value,
    onChange,
    inputFor,
    placeholder,
    indexOfActionButton,
    capitalize = true,
  }) => {
    return (
      <div className="field-wrapper">
        <Input
          name={name}
          label={label}
          isrequired={isRequired}
          value={value}
          placeholder={placeholder}
          onChange={(e) =>
            onChange(e, capitalize, inputFor, indexOfActionButton)
          }
          error={errors[name]}
          autoComplete="off"
        />
      </div>
    );
  };

  const renderSelectDropdownInputField = ({
    classNamePrefix,
    label,
    isRequired,
    value,
    options,
    onChange,
    placeholder,
    menuPlacement,
  }) => {
    return (
      <div className="field-wrapper">
        <Select
          classNamePrefix={classNamePrefix || null}
          label={label}
          value={value}
          options={options}
          onChange={(val) => onChange(val)}
          placeholder={placeholder}
          menuPlacement={menuPlacement}
        />
      </div>
    );
  };

  const renderActionButtons = () => {
    return actionButtons.map((button, index) => (
      <Row className="mb-4" key={index}>
        <Col className="d-flex align-items-center" md={4} lg={2}>
          <span className="action-title">{button?.actionNameIndex}</span>
        </Col>
        <Col>
          {renderTextInputField({
            name: button?.actionNameIndex,
            label: "Label",
            isRequired: false,
            value: button?.title,
            onChange: handleActionButtonInputChange,
            inputFor: "label",
            indexOfActionButton: index,
            placeholder: "Please enter button title",
          })}
        </Col>
        <Col>
          {renderTextInputField({
            name: `${button?.actionNameIndex}_content`,
            label: "Action URL",
            isRequired: false,
            value: button?.content,
            onChange: handleActionButtonInputChange,
            inputFor: "content",
            indexOfActionButton: index,
            placeholder: "Please enter action url",
          })}
        </Col>
        <Col md={1} lg={1}>
          <ButtonView
            // title="Add Action"
            icon={<MdDelete title="Delete" />}
            styles={"danger-outline extra-danger-styles"}
            extraStyles={"extra-style remove-action-btn"}
            onClick={() => onClickRemoveActionButton(button.actionNameIndex)}
          />
        </Col>
      </Row>
    ));
  };

  const renderLeftSideBlock = () => {
    return (
      <>
        <Row className="mb-4">
          <Col>
            {renderTextInputField({
              name: "title",
              label: "Title",
              isRequired: true,
              value: fields?.title,
              onChange: handleInputChange,
              placeholder: "Please enter title",
            })}
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            {renderTextInputField({
              name: "description",
              label: "Description",
              isRequired: true,
              value: fields?.description,
              onChange: handleInputChange,
              placeholder: "Please enter description",
            })}
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            {renderTextInputField({
              name: "notificationAction",
              label: "Notification Action",
              isRequired: false,
              value: fields?.notificationAction,
              onChange: handleInputChange,
              placeholder: "Please enter url",
              capitalize: false,
            })}
          </Col>
        </Row>
        <Row className="mb-4">
          <Col className="d-flex align-items-center">
            <span className="action-sub-title">Action Buttons</span>
          </Col>
          <Col className="d-flex justify-content-end">
            <ButtonView
              title="Add Action"
              icon={<FaPlus />}
              styles={"secondary"}
              extraStyles={"extra-style"}
              onClick={() => onClickAddActionButton()}
              disabled={actionButtons?.length === 3}
            />
          </Col>
        </Row>
        {/* render action button input fields */}
        {renderActionButtons()}{" "}
        <Row className="mb-4">
          <Col>
            {renderSelectDropdownInputField({
              classNamePrefix: "platform-menu-active",
              label: "Platform",
              isRequired: false,
              value: fields?.platform,
              options: platformsDropDownOptions,
              onChange: handleDropdownSelectionForPlatform,
              placeholder: "Please select target platform",
              menuPlacement: "auto",
            })}
          </Col>
        </Row>
      </>
    );
  };

  const renderRightSideBlock = () => {
    return (
      <div className="wrapper">
        <div className="image-block">
          <div
            className={`file-control-block ${
              fields?.fileURL && "with-remove-block"
            }`}
          >
            {fields?.fileURL ? (
              <div className="remove-block">
                <MdDelete
                  className="remove-icon"
                  title="Remove image"
                  size={20}
                  color="black"
                  onClick={() => handleOnClickRemoveImage()}
                />
              </div>
            ) : null}

            <input
              type="file"
              id="actual-btn"
              onChange={(e) => handleFileChange(e)}
              accept="image/*"
              hidden
            />
            <label htmlFor="actual-btn" className="actual-btn-content">
              Upload Image
            </label>
          </div>
          <img
            className="image-wrapper"
            src={
              fields?.fileURL ? fields?.fileURL : placeholderImageForUpload
              // : "https://via.placeholder.com/600x400?text=Upload+Image"
            }
            alt="image"
          />
        </div>
        <div className="submit-action-block">
          <ButtonView
            title="Cancel"
            styles={"light"}
            extraStyles={"extras"}
            onClick={() => history.goBack()}
          />
          {hasFieldsChanged() && initialFields?.title && (
            <ButtonView
              title="Save"
              styles={"secondary"}
              extraStyles={"extras"}
              onClick={() => onClickSave()}
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="update__notification--container">
      <div className="update__notification--header-wrapper">
        <div className="action">
          <FaArrowLeftLong size={25} onClick={onClickCancel} />
        </div>
        <div className="selection-block">
          <div className="title-content">Update Notification</div>
        </div>
        <div className="action-block">
          <div className="action-btn-wrapper">
            {userPermissions?.includes("send_notification") && (
              <ButtonView
                // title="Select Users"
                title="Send Notification"
                styles={"secondary"}
                // icon={<FaPlus />}
                onClick={() =>
                  history.push(`${SEND_NOTIFICATION_TO_USERS}/${id}`)
                }
                disabled={hasFieldsChanged() ? true : false}
              />
            )}
          </div>
        </div>
      </div>
      <div className="update__notification--content-block">
        <div className="left-side-block">
          {initialFields?.title && renderLeftSideBlock()}
        </div>
        <div className="right-side-block">
          {initialFields?.title && renderRightSideBlock()}
        </div>
      </div>
    </div>
  );
};

export default UpdateNotificationView;
